<template>
  <div class="page">
    <div class="top">
      <div class="top-user">
        <div class="user-name">
          <img src="@/assets/newUser/41.png" alt="">
          <span>Hi~晚上好！</span>
        </div>
        <div class="setting-icon">
          <img src="@/assets/newUser/39.png" alt="" @click="remind">
        </div>
      </div>
    </div>
    <div class="add-card">
      <div class="card-input">
        <span>设备/卡号：</span>
        <van-field
          v-model="bindIccid"
          type="tel"
          clear-trigger="always"
          class="ph-t"
          clearable
          placeholder="请输入设备/卡号"
        />
      </div>
      <van-button class="sumit" @click="sumbit">立即添加</van-button>
      <div class="el-bz" @click="help">
        <img src="@/assets/newUser/42.png">
        <span>登录添加失败？查看帮助</span>
      </div>
    </div>
    <div class="add-card-two">
      <div class="el-tiel">
        <div class="text">权益中心丨</div>
        <div class="text1">领券购好物</div>
      </div>
      <div class="el-img1">
        <img src="@/assets/newUser/43.png" alt="" @click="imgLink">
        <img src="@/assets/newUser/44.png" alt="" @click="imgLink1">
      </div>
    </div>
    <div v-if="dataList.length > 0" class="content-list">
      <div
        v-for="(item, index) in dataList"
        :key="index"
        class="list-item"
        @click="itemClick(item)"
      >
        <img
          v-if="item.cardType === '联通'"
          src="@/assets/newUser/45.png"
          alt=""
        >
        <img
          v-if="item.cardType === '移动'"
          src="@/assets/newUser/48.png"
          alt=""
        >
        <img
          v-if="item.cardType === '电信'"
          src="@/assets/newUser/49.png"
          alt=""
        >
        <span>{{ item.shiledCardNo }}</span>
      </div>
    </div>
    <img
      src="@/assets/newUser/46.png"
      class="kefuImg"
      alt=""
      @click="kefuHandle"
    >
    <van-dialog v-model="reacheShows" title="提示" :show-confirm-button="false">
      <div class="dialog-text">{{ bindErrorMsg }}</div>
      <div class="btn-vis">
        <van-button
          type="primary"
          class="dialog-btn2"
          @click="kefuHandle"
        >联系客服</van-button>
        <van-button
          type="primary"
          class="dialog-btn3"
          @click="order"
        >取消</van-button>
      </div>
    </van-dialog>
    <van-dialog
      v-model="helpShow"
      title="添加失败?"
      :show-confirm-button="false"
    >
      <div class="dialog-text">1.如遇到授权失败，请重新扫码登录。</div>
      <div class="dialog-text">2.检查卡号/设备号是否输入正确?</div>
      <div class="dialog-text">3.非我方平台的卡片、设备无法添加。</div>
      <div class="dialog-text">4.如需解除绑定，请联系客服处理。</div>
      <div class="dialog-text">如有疑问请前往公众号咨询客服</div>
      <div class="btn-vis" style="justify-content: center;">
        <van-button
          type="primary"
          class="dialog-btn3"
          @click="helpClose"
        >我知道了</van-button>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { wxRequest } from '@/api/user'
import { Toast, Dialog } from 'vant'
export default {
  data() {
    return {
      bindIccid: '',
      iccid: localStorage.getItem('iccid'),
      bindErrorMsg: '',
      code: localStorage.getItem('wxCode'),
      dataList: [],
      reacheShows: false,
      helpShow: false,
      userPhone: localStorage.getItem('userPhone'),
      isAutoHome: localStorage.getItem('isAutoHome')

    }
  },
  mounted() {
    this.iccid = localStorage.getItem('iccid')
    if (!this.userPhone || this.userPhone.length < 11) {
      // 没有手机号直接跳转登录页面
      this.$router.replace('/newUser/simLogin')
    } else {
      this.init()
    }
  },
  created() {
    this.iccid = localStorage.getItem('iccid')
    // 如果用户是从 simLogin.vue或者bindPhone.vue页面进来的，直接跳转home.vue， 注意：此处仅仅是从bindPhone.vue和simLogin.vue进来的。
    // 如果用户是从home.vue或者其它页面退出进来的。就不要直接跳转了。
    if (!this.userPhone || this.userPhone.length < 11) {
      // 没有手机号直接跳转登录页面
      this.$router.replace('/newUser/simLogin')
    } else {
      if (this.iccid && this.iccid.length > 5 && this.isAutoHome == 1) {
        // Toast.success('缓存等于'+this.isAutoHome)
        this.isAutoHome == 0
        localStorage.setItem('isAutoHome', 0)
        var data = {
          cardNo: this.iccid
        }
        this.itemClick(data)
      }
    }
  },
  methods: {
    init() {
      var params = {
        userPhone: localStorage.getItem('userPhone')
      }
      wxRequest('/sim/iccidList/userPhone', params, 'post').then((res) => {
        if (res.data.code === '200') {
          this.dataList = res.data.data
        } else {
          Toast.fail(res.data.message)
        }
      })
    },
    async itemClick(itemData) {
      const data = {
        requestId: itemData.cardNo,
        code: '1',
        isCode: 1
      }
      await wxRequest('sim/bind', data, 'get').then((res) => {
        if (res.data.code === '200') {
          const record = res.data.data
          const iccid = record.iccid;
          if(!record.phoneNo ||record.phoneNo==''){
            var recordLoginText = record.virtualNo;
            localStorage.setItem('recordLoginText', recordLoginText)
          }else{
            var recordLoginText = record.phoneNo;
            localStorage.setItem('recordLoginText', recordLoginText)
          }
          // var recordLoginText = record.phoneNo;
          // if ( !recordLoginText || recordLoginText.length < 3) {
          //       recordLoginText = record.virtualNo
          // }
          localStorage.setItem('PayImgUrl', record.imgUrl) 
          localStorage.setItem('isCode', true)
          localStorage.setItem('mobile', record.mobile)
          localStorage.setItem('isBindPhone', record.isBindPhone)
          localStorage.setItem('userPhone', record.userPhone) // 用户绑定得手机号
          localStorage.setItem('supplierTypeName', record.supplierTypeName)
          localStorage.setItem('wxHeadImg', record.wxHeadImg)
          localStorage.setItem('wxNickName', record.wxNickName)
          localStorage.setItem('supplierName', record.supplierName)
          localStorage.setItem('intoNo', record.intoNo)
          localStorage.setItem('iccid', record.iccid)
          localStorage.setItem('openId', record.openId)
          localStorage.setItem('virtualNo', record.virtualNo)
          localStorage.setItem('tuiPrice', record.tuiPrice) // 赠送金余额
          localStorage.setItem('firstLogin', 1)
          localStorage.setItem('basePkgGroup', record.basePkgGroup)
          this.$store.state.isBindPhone = record.isBindPhone
        //  this.$store.state.recordLoginText = recordLoginText
          this.$store.state.supplierCode = res.data.data.supplierCode
          this.$store.state.iccid = iccid
          this.$store.commit('setIccid', iccid)
          localStorage.setItem('newHome', 1)
          localStorage.setItem('isAutoHome', 0)
          this.isAutoHome == 0
          this.$store.state.newHome = 1
          this.$store.state.intoNo = record.intoNo
          sessionStorage.setItem('intoNo', record.intoNo)
          // 未实名的电信卡用户（通过cardType字段判断），实名认证时将只需要绑定
          const cardType = record.supplierTypeCode
          const _data = {
            requestId: iccid,
            code: this.code,
            userPhone: record.userPhone
          }
          if (
            record.supplierCode === '1574603917105295360' &&
            record.cardState === 11
          ) {
            // 深圳联通做特殊限制
            Dialog.confirm({
              title: '换卡提示',
              message:
                '由于运营商管控，当前卡已暂停激活使用。请点击 确定 将为你更换网速更快的移动卡。感谢你的理解和支持！'
            })
              .then(() => {
                window.location.href =
                  'http://webchat.szxxtx.com/#/user/chgCardQuery'
              })
              .catch(() => {})
          } else {
            wxRequest('sim/bindIccid/appid', _data, 'get').then((res) => {
              if (res.data.code === '400') {
                // 更新授权失败，直接跳转simLogin页面 重新授权。 此处需要测试
                window.location.href = 'http://wx.519liuliang.com/#/newUser/simLoginBase'
              } else if ((res.data.data && res.data.code === '200') || !this.code || res.data.code === '401') {
                wxRequest('sim/is/have/price', { iccid: iccid }, 'get').then((res) => {
                  localStorage.removeItem('wxCode')
                  if (res.data.code === '200') {
                    if (record.isBindPhone !== 1 ) {
                      this.$router.replace('/newUser/bindPhone')
                    } else {
                      localStorage.setItem('isAutoHome', 0)
                      this.isAutoHome == 0
                      this.$router.push({
                        path: '/newUser/home'
                      })
                    }
                  } else {
                    if (
                      record.basePkgGroup === '1549295580465852416' ||
                        record.basePkgGroup === '1568163178611732480'
                    ) {
                      // 悟空卡
                      this.$router.replace('/newUser/simOpenWu')
                    } else  if (
                        record.basePkgGroup === "1710104773937590272"
                      ) {
                        //楷然直播
                        this.$router.replace("/newUser/simOpen999");
                      }else if (
                      record.basePkgGroup === '1587749406130565120'
                    ) {
                      // 悟空卡Puls  105G
                      this.$router.replace('/newUser/simOpenWup')
                    } else if (
                      record.basePkgGroup === '1549295498467209216'
                    ) {
                      // 乐享卡
                      this.$router.replace('/newUser/simOpenLe')
                    } else if (
                      record.basePkgGroup === '1562613197939142656' ||
                        record.basePkgGroup === '1565598068475162624'
                    ) {
                      // 乐信卡 80元得240
                      this.$router.replace('/user/simOpenLex')
                    } else if (
                      record.basePkgGroup === '1574325852529750016' ||
                        record.basePkgGroup === '1574325802546229248'
                    ) {
                      // 悟净卡 开户预存 送赠送金
                      this.$router.replace('/user/cardOpens')
                    } else if (
                      record.basePkgGroup === '1579392078893281280' ||
                        record.basePkgGroup === '1579369236420096000' ||
                        record.basePkgGroup === '1579369201724813312'
                    ) {
                      // 冰星系列 开户预存+赠送金
                      this.$router.replace('/user/rechargePrice')
                      // 畅享卡系列 30*3+20*9优惠券  9.9元套餐
                    } else if (
                      record.basePkgGroup === '1588080292403343360'
                    ) {
                      this.$router.replace('/user/simOpenCxk')
                    }
                    // 畅享卡系列 30*2+20*10优惠券  9.9元套餐
                    else if (record.basePkgGroup === '1595609837910093824') {
                      this.$router.replace('/user/simOpenXy')
                    }
                    // 畅享卡系列 30*2+20*10优惠券  9.9元套餐
                    else if (record.basePkgGroup === '1595609014362697728') {
                      this.$router.replace('/newUser/simOpenYx')
                    } else if (
                      record.basePkgGroup === '1597081108845948928'
                    ) {
                      this.$router.replace('/newUser/simOpenXy8')
                    } else if (
                      record.basePkgGroup === '1620242289261539328'
                    ) {
                      this.$router.replace('/newUser/simOpenTn')
                    } else if (
                      record.basePkgGroup === '1630400735126482944'
                    ) {
                      this.$router.push({
                        path: '/newUser/simOpenTnP'
                      })
                    } else if (record.basePkgGroup === '1639175906637377536') {
                      this.$router.push({
                        path: '/newUser/simOpenXc'
                      })
                    }else if (record.basePkgGroup === '1647873729625059328') {
                        this.$router.replace('/newUser/simOpenTnVip')
                    }else if (record.basePkgGroup === '1643829249842343936') {
                        this.$router.replace('/newUser/simOpenTnBz')
                    } else if (record.basePkgGroup === '1643557236171075584') {
                        this.$router.replace('/newUser/simOpenXcp')
                    } else if (record.basePkgGroup === '1656908136637788160') {
                        this.$router.replace('/newUser/simOpenTnPUp')
                    } else if (record.basePkgGroup === '1671694964578316288') {
                        this.$router.replace('/newUser/simOpenZb')
                    }   else if (record.basePkgGroup === '1695020545449390080') {
                        this.$router.replace('/newUser/simOpen100')
                      } else if (record.basePkgGroup === '1695000953494695936') {
                        this.$router.replace('/newUser/simOpen105')
                      } else if (record.basePkgGroup === '1695000884909436928') {
                        this.$router.replace('/newUser/simOpen108')
                      } else if(record.saleType>=9){
                        this.$router.replace('/newUser/simAllOpen')
                      }
                      
                      else if (record.isBindPhone !== 1 ) {
                      this.$router.replace('/newUser/bindPhone')
                    } else {
                      localStorage.setItem('isAutoHome', 0)
                      this.isAutoHome == 0
                      this.$router.push({
                        path: '/newUser/home'
                      })
                    }
                  }
                })
              } else {
                Dialog.alert({
                  title: '提示',
                  message: '授权失败 请重新扫码登录！'
                })
              }
            })
          }
        } else {
          Dialog.alert({ title: '提示', message: res.data.message })
        }
      })
    },
    sumbit() {
      var userPhone = localStorage.getItem('userPhone')
      if (!userPhone || userPhone.length !== 11) {
        this.$router.push({
          path: '/newUser/simLogin'
        })
      } else {
        var params = {
          userPhone: userPhone,
          iccid: this.bindIccid
        }
        wxRequest('/sim/add/iccid/userPhone', params, 'post').then((res) => {
          if (res.data.code === '200') {
            this.init()
            Toast.success('绑定成功！')
          } else {
            this.bindErrorMsg = res.data.message
            this.reacheShows = true
          }
        })
      }
    },
    remind() {
      this.$router.push({
        path: '/user/notify'
      })
    },
    kefuHandle() {
      window.location.href = 'http://kefu.szxxtx.com/s/135302p4tv'
    },
    imgLink() {},
    imgLink1() {},
    order() {
      this.reacheShows = false
    },
    help() {
      this.helpShow = true
    },
    helpClose() {
      this.helpShow = false
    }
  }
}
</script>
<style lang="less" scoped>
div {
  display: flex;
  flex-grow: 0;
  flex-basis: auto;
  align-items: stretch;
  flex-direction: column;
}
.page {
  background: #f7f8fa;
  .top {
    height: 200px;
    background: url("../../assets/newUser/11.png") no-repeat center;
    background-size: 100%;
    .top-user {
      flex-direction: row;
      align-items: center;
      height: 60px;
      justify-content: space-between;
      margin: 0px 15px;
      .user-name {
        flex-direction: row;
        align-items: center;
        img {
          width: 42px;
          height: 39px;
          border-radius: 100px;
        }
        span {
          font-size: 17px;
          margin-left: 5px;
        }
      }
      .setting-icon {
        display: flex;
        flex-direction: row;
        img {
          width: 30px;
          height: 30px;
          line-height: 30px;
          font-weight: bold;
          margin-left: 7px;
          padding: unset;
        }
      }
    }
  }
  .add-card {
    width: 90%;
    background: #fff;
    border-radius: 15px;
    align-self: center;
    margin-top: 16px;
    align-items: center;
    padding-bottom: 16px;
    .card-input {
      width: 85%;
      height: 44px;
      border: 1px solid #bdc4ce;
      border-radius: 16px;
      flex-direction: row;
      align-items: center;
      padding-left: 10px;
      padding-right: 6px;
      margin-top: 16px;
      span {
        color: rgb(6, 18, 30);
        font-size: 15px;
      }
      .ph-t {
        flex: 1;
        color: #06121e;
        font-size: 15px;
        padding: 6px 10px;
      }
    }
    .sumit {
      width: 88%;
      height: 44px;
      border-radius: 16px;
      background: rgba(52, 118, 254, 0.1) !important;
      border: 0 !important;
      color: #3476fe;
      margin-top: 16px;
      line-height: 44px;
      text-align: center;
    }
    .el-bz {
      flex-direction: row;
      align-items: center;
      align-self: flex-start;
      margin: 16px 0px 0px 16px;
      img {
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }
      span {
        font-size: 14px;
        color: #06121e;
        line-height: 20px;
        text-decoration: underline;
      }
    }
  }
  .add-card-two {
    width: 90%;
    background: #fff;
    border-radius: 15px;
    align-self: center;
    margin-top: 16px;
    align-items: center;
    padding: 10px 10px;
    .el-tiel {
      flex-direction: row;
      width: 320px;
      align-items: center;
      margin-bottom: 5px;
      color: rgb(6, 18, 30);
      .text {
        font-size: 17px;
      }
      .text1 {
        font-size: 13px;
      }
    }
    .el-img1 {
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: space-around;
      img {
        width: 150px;
        height: 72px;
      }
    }
  }
  .content-list {
    width: 90%;
    align-self: center;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 16px;
    .list-item {
      width: 46%;
      height: 136px;
      background: #fff;
      border-radius: 16px;
      margin-bottom: 15px;
      img {
        width: 100%;
        height: 96px;
      }
      span {
        font-size: 14px;
        color: #06121e;
        text-align: center;
        margin-top: 10px;
      }
    }
  }
  .kefuImg {
    width: 73px;
    position: fixed;
    bottom: 35px;
    right: 15px;
    height: 74px;
  }
  .van-dialog {
    ::v-deep.van-dialog__content {
      flex-direction: column;
      justify-content: center;
      background-color: #fff;
      padding: 20px;
      border-radius: 10px;
      padding-top: 0px;
    }
    ::v-deep .van-dialog__header {
      font-size: 20px;
      font-weight: 700;
      color: #06121e;
      text-align: center;
      margin-bottom: 10px;
    }
    .dialog-text {
      font-size: 14px;
      color: #06121e;
      margin-top: 8px;
      line-height: 28px;
    }
    .btn-vis {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-top: 25px;
      .dialog-btn2 {
        width: 120px;
        height: 47px;
        color: #3476fe;
        text-align: center;
        background: rgba(52, 118, 254, 0.1) !important;
        border: 0 !important;
        border-radius: 94px;
        font-size: 16px;
        line-height: 47px;
      }
      .dialog-btn3 {
        width: 130px;
        height: 47px;
        border-radius: 94px;
        font-size: 16px;
        line-height: 47px;
        border: 0;
        color: #fff;
        background: #3476fe;
        text-align: center;
      }
    }
  }
}
</style>
